import Flickity from 'flickity';

const STRINGS = document.body.dataset.slider.split(',');

// Set additional default values
const DEFAULTS = {
    pageDotAriaLabel: STRINGS[0],
    previousAriaLabel: STRINGS[1],
    nextAriaLabel: STRINGS[2],
    arrowShape:
        'M33.8804653,19.4393398 C34.4317937,19.9906682 34.4642248,20.8643981 33.9777586,21.4536561 L33.8804653,21.5606602 L6.742,48.698 L97.3185034,48.6984848 C98.1469305,48.6984848 98.8185034,49.3700577 98.8185034,50.1984848 C98.8185034,50.9781809 98.2236153,51.6189335 97.4629634,51.6916182 L97.3185034,51.6984848 L6.742,51.698 L33.8804653,78.8363094 C34.4317937,79.3876379 34.4642248,80.2613677 33.9777586,80.8506257 L33.8804653,80.9576298 C33.3291369,81.5089582 32.455407,81.5413893 31.866149,81.054923 L31.759145,80.9576298 L1,50.1984848 L31.759145,19.4393398 C32.3449314,18.8535534 33.2946789,18.8535534 33.8804653,19.4393398 Z',
    on: {
        ready: function () {
            if (this.options.equalHeight) {
                setHeight(this, this.options.equalHeight);
            }
        },
        resize: function () {
            if (this.options.equalHeight) {
                setHeight(this, this.options.equalHeight);
            }
        },
    },
};

Object.assign(Flickity.defaults, DEFAULTS);

function setHeightElements(flkty, selector) {
    const ELEMENTS = flkty.cells
        .map((cell) => {
            const ELEMENT = cell.element;
            if (!selector) {
                return ELEMENT;
            }
            return ELEMENT.querySelector(selector);
        })
        .filter((element) => !!element);
    if (!ELEMENTS.length) {
        return;
    }
    ELEMENTS.forEach((element) => (element.style.minHeight = '0'));
    setTimeout(() => {
        const HEIGHTS = ELEMENTS.map((element) => element.offsetHeight);
        const MAX = Math.max(...HEIGHTS);
        ELEMENTS.forEach((element) => (element.style.minHeight = MAX + 'px'));
    }, 10);
}

function setHeight(flkty, selector) {
    if (typeof selector === 'string') {
        selector.split(',').forEach((item) => setHeightElements(flkty, item));
    } else {
        setHeightElements(flkty);
    }
}

// Add localized labels with this duck-punch code
// https://metafizzy.co/blog/duck-punching-prototype/

let addDots = Flickity.PageDots.prototype.addDots;
Flickity.PageDots.prototype.addDots = function () {
    addDots.apply(this, arguments);
    let ariaLabel = this.parent.options.pageDotAriaLabel;
    this.dots.forEach(function (dot, i) {
        let label = ariaLabel.replace('%n', i + 1);
        dot.setAttribute('aria-label', label);
    });
};

let _createButton = Flickity.PrevNextButton.prototype._create;
Flickity.PrevNextButton.prototype._create = function () {
    _createButton.apply(this, arguments);
    let optionName = this.isPrevious ? 'previous' : 'next';
    let label = this.parent.options[optionName + 'AriaLabel'];
    this.element.setAttribute('aria-label', label);
};

let watchCSS = Flickity.PageDots.prototype.watchCSS;
Flickity.prototype.watchCSS = function () {
    let watchOption = this.options.watchCSS;
    let cells = typeof this.cells === 'object' ? this.cells : false;
    if (!watchOption) {
        return;
    }

    let afterContent = getComputedStyle(this.element, ':after').content;
    // activate if :after { content: 'flickity' }
    if (afterContent.indexOf('flickity') != -1) {
        this.activate();
    } else {
        if (cells) {
            cells.forEach((cell) => {
                if (this.options.equalHeight) {
                    cell.element.style.minHeight = '0';
                }
                cell.element.removeAttribute('aria-hidden');
            });
        }
        this.deactivate();
    }
};

export default Flickity;
